module.exports = __webpack_public_path__ + "img/siem.de66b24.svg";